import { db$, dispatch } from 'nike-re-framejs';
import { combineLatest, timer } from 'rxjs';
import { map, scan, delayWhen, distinctUntilChanged, filter } from 'rxjs/operators';

import { cmdStream$ } from './command';
import { setKey } from '@/services/localStorage';
import { subscribeToTicket } from '@/notifications/handlers';
import { changeTicketusActiveMark } from '@/mytickets/active/handlers';
import { clientLog } from 'nike-ui/src/common/logging/logs';
import { BetslipLog } from 'nike-ui/src/common/logging/BetslipLog';
import { trackBetslipSubmit } from 'nike-ui/src/analytics/events/betslip';
import moment from 'moment';

export default function subscribeSubmitStreams() {
    db$.pipe(
        map(db => db.getIn(['server', 'betslip', 'nextPollTime'])),
        filter(Boolean),
        scan((acc, time) => (time > acc ? time : acc), 0),
        distinctUntilChanged(),
        delayWhen(time => timer(new Date(time)))
    ).subscribe(() => {
        const submit = db$.getValue().getIn(['server', 'betslip', 'submit']);

        // If submit status is anything else than Accepted or NotAccepted, poll betslip
        if (submit != null && !['Accepted', 'NotAccepted'].includes(submit.get('status'))) {
            cmdStream$.next(['PollBetslip', {}]);
        }
    });

    db$.pipe(
        map(db => db.getIn(['server', 'betslip', 'submit', 'submitted'])),
        distinctUntilChanged(),
        scan(([_, oldValue], newValue) => [oldValue, newValue], [null, false]),
        filter(([oldValue, newValue]) => oldValue === false && newValue)
    ).subscribe(() => {
        const dbValue = db$.getValue();
        const betslip = dbValue.getIn(['server', 'betslip']);
        const ticketTracking = dbValue.getIn(['notifications', 'settings', 'ticketTracking']);
        const picksTracking = dbValue.getIn(['notifications', 'settings', 'picksTracking']);

        if (ticketTracking || picksTracking) {
            dispatch(subscribeToTicket(betslip.getIn(['submit', 'ticketId']), ticketTracking, picksTracking));
        }
        dispatch(['account.updateUserData']);
        dispatch(changeTicketusActiveMark);
        addAnalyticsTransaction(betslip);
        logSubmitDuration(betslip, dbValue.getIn(['betslip', 'submitting']));
        trackBetslipSubmit(betslip.toJS());
    });

    combineLatest(
        db$.pipe(
            map(db => db.getIn(['server', 'betslip', 'savedBetslipParams'])),
            distinctUntilChanged()
        ),
        db$.pipe(
            map(db => db.getIn(['server', 'betslip', 'totals'])),
            distinctUntilChanged()
        ),
        db$.pipe(
            map(db => db.getIn(['loggedIn'])),
            distinctUntilChanged()
        )
    )
        .pipe(
            //ak je to ulozeny tiket a zaroven uzivatel nie je prihlaseny -> uloz do LS, do profilu je ukladany automaticky
            filter(([saved, totals, loggedIn]) => saved && totals && !loggedIn)
        )
        .subscribe(([betslipParams]) => {
            dispatch(['ticketus/device-saved/toLS', betslipParams.get('ticketNumber')]);
        });
}

// noinspection JSUnusedLocalSymbols
function addAnalyticsTransaction(betslip) {
    setKey('ticketSubmitDate', JSON.stringify(moment().valueOf()));
    setKey('ticketSubmitCount', 1);
}

function logSubmitDuration(betslip, startOn) {
    if (startOn) {
        const duration = new Date().getTime() - startOn;
        // nebudeme logovat dlhsie ako 2 minuty lebo to urcite nie je realny log
        if (duration < 2 * 60 * 1000) {
            const data = {
                ticket: {
                    betslip_id: betslip.get('betslipId'),
                    ticket_id: betslip.getIn(['submit', 'ticketId']),
                    betslip_type: betslip.get('type'), // Standard, System
                    type: betslip.get('gameType'), // Prematch, Live, Hybrid, Virtual
                    submit_duration: duration,
                    submit_status: betslip.getIn(['submit', 'status']),
                    channel: 'MOBILE'
                }
            };

            // tieto betslip logy este nie su dokonale zjednotene! :/
            let cmd = 'Unknown CMD';

            clientLog(
                BetslipLog({
                    message: `Betslip submit finished after ${duration}ms by ${cmd}`,
                    data
                })
            );
        }
    }
}
